var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPessoa01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    d: "M18,17.6c2.3,0,4.4-0.9,6-2.5c1.6-1.6,2.5-3.7,2.5-6c0-2.3-0.9-4.4-2.5-6c-3.3-3.3-8.7-3.3-12,0 c0,0,0,0,0,0c-1.6,1.6-2.5,3.7-2.5,6c0,2.3,0.9,4.4,2.5,6C13.6,16.7,15.7,17.6,18,17.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_840",
    d: "M32.6,27.7c-0.1-0.7-0.2-1.5-0.3-2.2c-0.1-0.8-0.3-1.5-0.5-2.2c-0.2-0.7-0.5-1.4-0.9-2.1 c-0.4-0.7-0.8-1.3-1.4-1.8c-0.6-0.5-1.3-1-2-1.3c-0.8-0.3-1.7-0.5-2.5-0.5c-0.5,0.1-1,0.3-1.4,0.6c-0.4,0.3-0.9,0.6-1.4,0.9 c-0.6,0.3-1.2,0.6-1.9,0.8c-1.5,0.5-3.1,0.5-4.5,0c-0.6-0.2-1.3-0.5-1.9-0.8c-0.5-0.3-1-0.7-1.4-0.9c-0.4-0.3-0.9-0.5-1.4-0.6 c-0.9,0-1.7,0.1-2.5,0.5c-0.7,0.3-1.4,0.7-2,1.3c-0.5,0.5-1,1.1-1.4,1.8c-0.4,0.7-0.7,1.4-0.9,2.1C4,24,3.8,24.7,3.7,25.5 c-0.1,0.7-0.2,1.5-0.3,2.2c0,0.7-0.1,1.4-0.1,2.1c-0.1,1.7,0.6,3.3,1.7,4.4c1.2,1.1,2.8,1.7,4.5,1.6h17c1.6,0.1,3.3-0.5,4.5-1.6 c1.2-1.2,1.8-2.8,1.7-4.4C32.7,29.1,32.7,28.4,32.6,27.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPessoa01);
export default __webpack_public_path__ + "static/media/ico-pessoa-01.febab4e467cf564c46be099958b519e2.svg";
export { ForwardRef as ReactComponent };